@if (data) {
<div class="flex w-full">
  <div class="settings-log pl-24 w-[55%]">
    <div class="label-text flex mt-24 fw-700 fs-16">
      <div class="config-key">{{ 'TENANT_DETAILS.LOCAL_CONFIG' | transloco }}</div>
      <div>:&nbsp;</div>

      @if (data) {
        <div class="val fw-400 fs-16 flex flex-row" [ngClass]="data?.localConfigStatus">
          @if (data?.localConfigStatus) {
            <mat-icon [svgIcon]="data?.localConfigStatus === 'applied' ? 'check_circle' : 'error'" class="icon-md mr-6 mt-2">
            </mat-icon>
          }
          {{ data?.localConfigStatus ? (data?.localConfigStatus | titlecase) : '--' }}
        </div>
      } @else {
        <div class="pl-6 skeleton-loader">
          <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>

    <div class="label-text flex mt-24 fw-700 fs-16">
      <div class="config-key">{{ 'TENANT_DETAILS.EXECUTED_ON' | transloco }}</div>
      <div>:&nbsp;</div>

      @if (data) {
        <div class="val fw-400 fs-16">
          {{ data?.localConfigExecutedAt ? (data?.localConfigExecutedAt | date: 'dd MMM yyyy, HH:mm': 'UTC') + ' UTC' : '--' }}
        </div>
      } @else {
        <div class="pl-6 skeleton-loader">
          <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>
  @if(!fetchMigrateFailed && !isAWS){
  <div class="settings-log pl-24 w-[45%] ml-16">
    @if(!showMigrateLoader){
    <div class="flex justify-end items-center gap-2 mb-4">
      @if(isMigrationFailed || isMigrating){
      <div class="flex flex-row justify-center items-center pt-4 pr-8 pb-4 pl-4 mr-12 ml-12"
        [ngClass]="isMigrating ? 'width-status' : 'migration-failed'">
        <div class="flex flex-row width-fit pl-8 pr-8">
          @if(isMigrating){
          <mat-spinner diameter="24" class="w-16 h-16 mr-4 mt-4 migrating"></mat-spinner>
          } @else {
          <mat-icon svgIcon="close" class="icon-sm mr-6 mt-4 mig-failed"></mat-icon>
          }
          <span class="status-button">
            {{
            isMigrating
            ? ('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.MIGRATING' | transloco)
            : ('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.MIGRATION_FAILED' | transloco)
            }}
          </span>
        </div>
      </div>
      }
      <div class="tooltip-wrapper">
        <mat-icon class="cursor-pointer info-icon icon-md" svgIcon="info" (click)="tooltipVisible = true">
        </mat-icon>
        <div *ngIf="tooltipVisible" class="custom-tooltip p-16">
          <div class="flex justify-end">
            <mat-icon class="w-16 h-16 cursor-pointer" svgIcon="close" (click)="tooltipVisible = false">
            </mat-icon>
          </div>
          <div class="fs-16 fw-500 mat-body-2 mb-10 mt-8">
            {{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.MIGRATE_TOOLTIP_NOTE' | transloco }}
          </div>
          <div class="flex items-center cursor-pointer mt-5" (click)="openUrl()">
            <mat-icon svgIcon="open_in_new" class="mr-6"></mat-icon>
            <span class="underline fw-500 underline-offset">
              {{ 'TENANT_LIST.GO_TO_DOCUMENTATION' | transloco }}
            </span>
          </div>
          <div class="tooltip-arrow"></div>
        </div>
      </div>
      <button class="accent" (click)="confirmMigrate()" [matTooltip]="isMigrating ? ('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.MIGRATION_IN_PROGRESS' | transloco) : disableMigrate
              ? ('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.DISBALE_MIGRATE_NOTE' | transloco) : ''"  matTooltipClass="above" matTooltipPosition="{{Constants.POSITION_ABOVE}}"
        [disabled]="isMigrating || disableMigrate">
        {{ 'BUTTONS.MIGRATE' | transloco }}
      </button>
    </div>
    <div class="p-24 whitespace-pre-line text-center justify-center flex"
      [innerHTML]="('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.MIGRATE_NOTE' | transloco)">
    </div>
  } @else {
    <div class="pl-6 skeleton-loader">
          <ngx-skeleton-loader count="3" appearance="line"></ngx-skeleton-loader>
        </div>
  }
  </div>
}
</div>
} @else {
<div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-150">
  <img src="/assets/images/instance-not-found-small.png" />
  <div class="ml-10">{{ 'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
</div>
}